import { UTCDate } from '@/utils/dates';
import { Stack } from '../../../../../design-system/stack/stack';
import { TransactionView } from '../../../../../types/entity-types';
import { CardTransactionRow } from './card-transaction-row';

const MAX_TRANSACTIONS = 5;

type CardTransactionsProps = {
  transactions: TransactionView[];
  onSelectTransaction?: (id: string) => void;
};

export const CardTransactions = ({ transactions, onSelectTransaction }: CardTransactionsProps) => {
  const recentTransactions = [...transactions]
    .sort((a, b) => new UTCDate(b.fspDate).getTime() - new UTCDate(a.fspDate).getTime())
    .slice(0, MAX_TRANSACTIONS);

  if (recentTransactions.length === 0) {
    return null;
  }

  return (
    <Stack space={4} className="w-full">
      <p className="text-base leading-[22px] font-medium tracking-[-0.02em] text-foreground">Recent transactions</p>

      <Stack space={0} className="w-full overflow-hidden rounded-lg border border-border">
        {recentTransactions.map((transaction, index) => (
          <CardTransactionRow
            key={transaction.id}
            transaction={transaction}
            onClick={onSelectTransaction ? () => onSelectTransaction(transaction.id) : undefined}
            showBorder={index < recentTransactions.length - 1}
          />
        ))}
      </Stack>
    </Stack>
  );
};
